import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { api } from '../../api';
import { t } from '../../i18n';

/** Student portal — read-only view of the accepted contract with the date. */
@customElement('cadence-portal-contract')
export class CadencePortalContract extends LitElement {
  @state() private contract: { version: number; accepted_at: string | null; content_html: string | null } | null = null;
  @state() private loading = true;

  static styles = css`
    :host { display: block; }
    h1 { margin: 0 0 4px; font-size: 1.6rem; }
    .accepted { color: var(--color-text-secondary); font-size: 0.9rem; margin: 0 0 var(--space-4); }
    .doc { border: 1px solid var(--color-border); border-radius: var(--radius-md); padding: var(--space-5); background: var(--color-bg-primary); }
    .doc :first-child { margin-top: 0; }
  `;

  connectedCallback(): void { super.connectedCallback(); this.load(); }
  private async load() {
    this.loading = true;
    try { this.contract = await api.get('/portal/contract'); }
    finally { this.loading = false; }
  }

  render() {
    if (this.loading) return html`<cadence-loading></cadence-loading>`;
    if (!this.contract) {
      return html`<h1>${t('common.portal.contractTitle')}</h1><cadence-empty-state heading=${t('common.portal.noContract')}></cadence-empty-state>`;
    }
    const c = this.contract;
    const date = c.accepted_at ? new Date(c.accepted_at + 'Z').toLocaleString() : '—';
    return html`
      <h1>${t('common.portal.contractTitle')}</h1>
      <p class="accepted">${t('common.portal.acceptedOn', { date, version: c.version })}</p>
      <div class="doc">${c.content_html ? unsafeHTML(c.content_html) : ''}</div>
    `;
  }
}
